import { render, staticRenderFns } from "./WebcastList.vue?vue&type=template&id=21531a1e&"
import script from "./WebcastList.vue?vue&type=script&lang=js&"
export * from "./WebcastList.vue?vue&type=script&lang=js&"
import style0 from "./WebcastList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports